__turbopack_context__.v({
  "colored-line": "StepperComponent-module-scss-module__eKeU0W__colored-line",
  "line": "StepperComponent-module-scss-module__eKeU0W__line",
  "step": "StepperComponent-module-scss-module__eKeU0W__step",
  "step-clickable": "StepperComponent-module-scss-module__eKeU0W__step-clickable",
  "step-current": "StepperComponent-module-scss-module__eKeU0W__step-current",
  "text": "StepperComponent-module-scss-module__eKeU0W__text",
  "wrapper": "StepperComponent-module-scss-module__eKeU0W__wrapper",
});
